import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "/Logo.png";
    // { name: 'How It Works', href: '#process' },
    // { name: 'Case Studies', href: '#case-studies' },
const navLinks = [
    { name: 'Testimonials', href: '#video-feedback' },
    { name: 'Services', href: '#services' },
    // { name: 'Contact', href: '#contact' },
];

export const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (href) => {
        setIsMobileMenuOpen(false);
        const element = document.querySelector(href);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <motion.nav
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.5 }}
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
                isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
            }`}
            data-testid="navbar"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="flex items-center justify-between h-20">
                    {/* Logo */}
                    <a href="#" className="flex items-center gap-3" data-testid="navbar-logo">
                        <img 
                            src={LOGO_URL} 
                            alt="Digital Enabler HQ" 
                            className="h-10 w-auto"
                        />
                        <span className="text-[#2C2C2C] font-semibold text-lg">Digital Enabler HQ</span>
                    </a>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center gap-8">
                        {navLinks.map((link) => (
                            <button
                                key={link.name}
                                onClick={() => scrollToSection(link.href)}
                                className="text-[#6B6B6B] hover:text-[#2C2C2C] text-sm font-medium transition-colors duration-200"
                                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                            >
                                {link.name}
                            </button>
                        ))}
                        <button
                            onClick={() => scrollToSection('#contact')}
                            className="bg-[#34A853] hover:bg-[#2E9648] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
                            data-testid="nav-cta-button"
                        >
                            Book a Call
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden text-[#2C2C2C] p-2"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        data-testid="mobile-menu-button"
                    >
                        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            <AnimatePresence>
                {isMobileMenuOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        className="md:hidden bg-white border-t border-[#E5E5E5]"
                        data-testid="mobile-menu"
                    >
                        <div className="px-6 py-4 space-y-4">
                            {navLinks.map((link) => (
                                <button
                                    key={link.name}
                                    onClick={() => scrollToSection(link.href)}
                                    className="block w-full text-left text-[#6B6B6B] hover:text-[#2C2C2C] text-base font-medium py-2 transition-colors duration-200"
                                >
                                    {link.name}
                                </button>
                            ))}
                            <button
                                onClick={() => scrollToSection('#contact')}
                                className="w-full bg-[#34A853] hover:bg-[#2E9648] text-white px-6 py-3 rounded-full text-sm font-medium transition-colors duration-200"
                            >
                                Book a Call
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.nav>
    );
};
